import Dashboard from "@/pages/Dashboard/Dashboard";
import Inventory from "@/pages/Inventory/Inventory";
import Notification from "@/pages/Notification/Notification";
import Profile from "@/pages/Profile/Profile";
import EmptyContainer from "@/pages/EmptyContainer/EmptyContainer";
import Updates from "@/pages/Updates/Updates";
import CreateAppOrder from "@/pages/Planning/OrderApplication/Create/CreateOrderApplication";
import LoadInventory from "@/pages/Inventory/LoadInventory/LoadInventory";
import MaintainersProducts from "@/pages/Maintainers/Products/Products";
import PlanningHome from "@/pages/Planning/Home/PlanningHome";
import PhytosanitaryProgram from "@/pages/Planning/PhytosanitaryProgram/PhytosanitaryProgram";
import OA from "@/pages/Planning/OA/OA";
import InventoryTaking from "@/pages/InventoryTaking/InventoryTaking";
import { HistoryOrRedirect, OAOrRedirect } from "./core.route-components";

const userRole = () => ["administrador", "gerente_agricola", "administrador_campo", "usuario"];

export const coreRoutes = [
	{
		path: `/`,
		Component: Dashboard,
		roles: [...userRole(), "mantenimiento"],
	},
	{
		path: `/historial_aplicaciones/:option?/:action?/:application_history_id?`,
		Component: HistoryOrRedirect,
		roles: userRole(),
	},
	{
		path: `/envases_vacios`,
		Component: EmptyContainer,
		roles: userRole(),
	},
	{
		path: `/carga_inventario_inicial`,
		Component: LoadInventory,
		roles: userRole(),
	},
	{
		path: `/notificaciones`,
		Component: Notification,
		roles: userRole(),
	},
	{
		path: `/perfil`,
		Component: Profile,
		roles: userRole(),
	},
	{
		path: `/planificacion`,
		Component: PlanningHome,
		roles: userRole(),
	},
	{
		path: `/planificacion/programa_fitosanitario`,
		Component: PhytosanitaryProgram,
		roles: userRole(),
	},
	{
		path: `/planificacion/ordenes_aplicacion`,
		Component: OA,
		roles: userRole(),
	},
	{
		path: `/inventario/:option?/:product_id?/:inventory_id?`,
		Component: Inventory,
		roles: userRole(),
	},
	{
		path: `/productos/:section?/:option?/:product_id?/:inventory_id?`,
		Component: MaintainersProducts,
		roles: userRole(),
	},
	{
		path: `/soporte/actualizaciones`,
		Component: Updates,
		roles: userRole(),
	},
	{
		path: `/ordenes_aplicacion/:option?/:code?`,
		Component: OAOrRedirect,
		roles: userRole(),
	},
	{
		path: `/orden_aplicacion/:option?/:code?`,
		Component: CreateAppOrder,
		roles: userRole(),
	},
	{
		path: `/tomas_de_inventario`,
		Component: InventoryTaking,
		roles: userRole(),
	},
];
